import { styled } from '@ori-ui/mui';

import { TOP_AREA_BANNER_HEIGHT } from '../../constants';

export const Root = styled('div')(({ theme }) => ({
  margin: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  zIndex: theme.zIndex.appBar,
  backgroundColor: theme.palette.offer.light,
  height: TOP_AREA_BANNER_HEIGHT,
}));
